const builtInVoxelStatistics = {
    Average: 'average',
    ForegroundMajority: 'foregroundMajority',
};
const VoxelStatistics = builtInVoxelStatistics;
export function registerVoxelStatisticsConstant(name, statistic) {
    if (Object.prototype.hasOwnProperty.call(VoxelStatistics, name)) {
        throw new Error(`Voxel statistic constant "${String(name)}" already exists`);
    }
    VoxelStatistics[name] =
        statistic;
}
export default VoxelStatistics;
